import React, { Component } from 'react';
import { connect } from 'react-redux';
import { incrementVideoPlayerId } from '../../store/ads/actions';
import { getVideoPlayerId } from '../../store/reducers';
import { IS_PROD } from '../../settings';

import styles from './VideoSiderailPlayer.scss';
// import PlaywireBoltLoader from '../../containers/PlaywireBoltLoader';

class VideoSiderailPlayer extends Component {
  componentWillUnmount() {
    this.props.incrementVideoPlayerId();
  }

  render() {
    return (
      <div className="VideoSiderailPlayer">
        {/* <PlaywireBoltLoader
          scriptConfigUri="//config.playwire.com/1024392/playlists/v2/5156/zeus.json"
          playerId={this.props.playerId}
          autoplay
          type="siderail"
        >
          <div
            className="siderailPlayer"
            id={`bolt-siderail-${this.props.playerId}`}
          />
        </PlaywireBoltLoader> */}
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    playerId: getVideoPlayerId(state),
  };
};

const VideoSiderailPlayerComponent = connect(mapStateToProps, { incrementVideoPlayerId })(VideoSiderailPlayer);

export default VideoSiderailPlayerComponent;
